"use client";

import React, { useCallback } from "react";
import { useRouter } from "next/navigation";
import { ContactDetailsTab as ReusableContactDetailsTab } from "@/components/shared/detail-tabs/ContactDetailsTab";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Time_Entries } from "@/src/gql/graphql";

/**
 * Time Entry Contact Details Tab Component
 *
 * Wraps the reusable ContactDetailsTab with time entry-specific context.
 */
export function ContactDetailsTab({ item }: TabContentProps<Time_Entries>) {
  const router = useRouter();
  const contact = (item as any).contacts;

  const handleViewFullContact = useCallback(
    (id: string) => {
      router.push(`/contacts/${id}`);
    },
    [router]
  );

  return (
    <ReusableContactDetailsTab
      contactId={contact?.id}
      contactData={contact}
      onViewFullContact={handleViewFullContact}
      showDescription="Contact associated with this time entry"
    />
  );
}
